// extracted by mini-css-extract-plugin
module.exports = {"mfaGaSetupQrImg":"mfaGaSetupModal_mfaGaSetupQrImg__2vWgc","otpContainer":"mfaGaSetupModal_otpContainer__H6ORt","otpInput":"mfaGaSetupModal_otpInput__2-eZI"};